import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { or } from 'ember-truth-helpers';
import SettingsCurrencyConversionLandingPage from 'lumen/components/settings/currency-conversion/landing-page';
import SettingsCurrencyConversionModalsNotFoundProfile from 'lumen/components/settings/currency-conversion/modals/not-found-profile';
import SettingsCurrencyConversionModalsOnboarding from 'lumen/components/settings/currency-conversion/modals/onboarding';
import type MarketSettingsCurrencyConversionIndexController from 'lumen/controllers/market/settings/currency-conversion/index';
import type MarketSettingsCurrencyConversionIndexRoute from 'lumen/routes/market/settings/currency-conversion/index';
import type { ModelFrom } from 'lumen/utils/routes';

interface MarketSettingsCurrencyConversionIndexSignature {
  Args: {
    controller: MarketSettingsCurrencyConversionIndexController;
    model: ModelFrom<MarketSettingsCurrencyConversionIndexRoute>;
  };
}

const MarketSettingsCurrencyConversionIndex: TOC<MarketSettingsCurrencyConversionIndexSignature> =
  <template>
    {{#if @model.exchangeRatesProfiles.isRunning}}
      <PrismLoadingBar />
    {{/if}}

    <SettingsCurrencyConversionLandingPage
      @baseCurrencies={{or @model.baseCurrencies.last.value (array)}}
      @exchangeRatesProfiles={{or
        @model.exchangeRatesProfiles.last.value
        (array)
      }}
      @isBannerDismissed={{@controller.isBannerDismissed}}
      @isLoading={{@model.exchangeRatesProfiles.isRunning}}
      @isReadOnly={{@controller.isReadOnly}}
      @onDismissBanner={{@controller.dismissBanner}}
    />

    {{outlet}}

    {{#if @controller.showProfileNotFoundModal}}
      <SettingsCurrencyConversionModalsNotFoundProfile
        @onClose={{@controller.closeProfileNotFoundModal}}
      />
    {{/if}}

    {{#if @controller.showUserOnboardingModal}}
      <SettingsCurrencyConversionModalsOnboarding
        @onClose={{@controller.closeUserOnboardingModal}}
      />
    {{/if}}
  </template>;

export default MarketSettingsCurrencyConversionIndex;
